"use client";

import dynamic from "next/dynamic";

const CustomerHomeClient = dynamic(() => import("./customer-home-client").then((module) => module.CustomerHomeClient), {
  ssr: false
});

export default function CustomerHomePage() {
  return <CustomerHomeClient />;
}